import { Component, OnDestroy, OnInit } from '@angular/core';
import {MessageService} from 'primeng/api';
import {TasksService} from '../../../_services/tasks.service';
import {Subscription} from 'rxjs';
import {GenericMessage} from '@cas-hub/acabim-common-client';

@Component({
  selector: 'acabim-admin-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit, OnDestroy {

  tasksServiceSubscription = new Subscription();

  constructor(
      private messageService: MessageService,
      private readonly tasksService: TasksService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.tasksServiceSubscription.unsubscribe();
  }

  runActions(): void {
    this.tasksServiceSubscription = this.tasksService.runTasks().subscribe((result: GenericMessage) => {
      this.messageService.clear('superTasks');
      if (result.success) {
        this.messageService.add({severity: 'success', summary: 'Action tasks', detail: 'Successfully processed action tasks. ' + result.message, key: 'superTasks'});
      } else {
        this.messageService.add({severity: 'error', summary: 'Action tasks', detail: 'Something went wrong. Please try again later', key: 'superTasks'});
      }
    });
  }

}
